<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="800px">
    <v-card v-if="item && item.type == 'fileblock'">
      <v-toolbar 
        color="primary" 
        dark>
        <v-toolbar-title>
          <span class="headline">Add file upload</span>            
        </v-toolbar-title>
      </v-toolbar>
      <v-card 
        v-show="item.label || item.value" 
        color="secondary lighten-5">
        <v-layout
          row 
          wrap>
          <v-flex
            sm12
            md1
            class="secondary"
          >    
            <v-layout 
              align-center 
              justify-center 
              fill-height 
              row>       
              <v-tooltip bottom>
                <v-icon slot="activator">visibility</v-icon>
                <span>Preview</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex 
            sm12 
            md11>
            <v-card-text>
              <v-btn 
                raised 
                class="primary" 
                @click="onPickFile">{{ item.label }}</v-btn>
              <input
                ref="fileInput"
                type="file"
                style="display: none"
                :accept="item.fileType"> 
            </v-card-text> 
          </v-flex>
        </v-layout>   
      </v-card> 
      <v-form 
        ref="form"
        v-model="valid"              
        lazy-validation>       
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="item.label"
                  :rules="labelRules"
                  label="Label"                                           
                  required
                  hint="Label for upload field"  
                />
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="item.fileType"
                  :items="fileTypes"
                  label="Accept file type"
                  item-text="text"
                  item-value="value"
                  required
                  :rules="[v => !!v || 'Required']"
                />
              </v-flex>          
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.required"
                  persistent-hint
                  hint="Is the text field mandatory"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Required"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Optional"                      
                    color="primary" 
                  />
                </v-radio-group>                
              </v-flex>
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.show"
                  persistent-hint
                  hint="Should the element be displayed when editing a form or always"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Show always"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Show in form"                      
                    color="primary" 
                  />
                </v-radio-group>    
                <v-flex xs12>
                  <v-checkbox 
                    v-model="item.csv" 
                    label="Include element in CSV"/>
                </v-flex>
                <v-flex 
                  xs12 
                  v-if="item.csv"> 
                  <v-btn 
                    v-if="suggestedKey && suggestedKey != item.csvKey" 
                    block
                    @click="item.csvKey = suggestedKey"
                    :value="suggestedKey">Use key: "{{ suggestedKey }}"</v-btn>              
                  <v-text-field
                    :rules="csvRules"
                    v-model="item.csvKey"                  
                    label="CSV key"  
                    persistent-hint
                    hint="CSV headers are generated from these Keys and must be unique"
                  />                
                </v-flex>             
              </v-flex>             
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="primary" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="fileitem.label" 
            color="red darken-1" 
            flat 
            @click.native="remove()">Delete</v-btn>         
          <v-btn 
            color="primary" 
            flat 
            @click.native="save(item)">{{ (fileitem.label ? 'Update' : 'Save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Fileblock",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    fileitem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: true,
      labelRules: [
        v => !!v || "Required",
        v => (!!v && v.length < 100) || "Text must be less than 100 characters"
      ],
      csvRules: [
        v => !!v || "Required",
        v => /^[a-zA-Z0-9_]+$/.test(v) || "Alphanumeric and underscore"
      ],
      fileTypes: [
        {
          value:
            ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          text: "Document"
        },
        { value: ".pdf,application/pdf", text: "PDF" },
        { value: "image/*", text: "Image" },
        { value: "*", text: "Any" }
      ],
      item: null
    };
  },
  watch: {
    fileitem: function(val) {
      this.item = JSON.parse(JSON.stringify(val));
    }
  },
  computed: {
    suggestedKey: function() {
      if (this.item && this.item.label) {
        return this.item.label
          .replace(/\s+/g, "_")
          .replace(/[^a-zA-Z0-9_]/g, "")
          .toUpperCase();
      }
      return null;
    }
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click();
    },
    save(item) {
      if (this.$refs.form.validate()) {
        this.$emit("statusDialog", false);
        this.$emit("saveItem", item);
        this.$store.dispatch("setLoading", true);
      }
    },
    remove() {
      this.$emit("statusDialog", false);
      this.$emit("saveItem", null);
      this.$store.dispatch("setLoading", true);
    },
    close() {
      this.$emit("statusDialog", false);
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "warning",
        text: "File input not saved"
      });
    }
  }
};
</script>
